// extracted by mini-css-extract-plugin
export var attribution = "_2p-4";
export var authorName = "_2p-5";
export var option = "_2p-g";
export var optionCard = "_2p-v";
export var optionContent = "_2p-w";
export var optionGrid = "_2p-12";
export var optionIcon = "_2p-y";
export var optionIconBox = "_2p-x";
export var optionLabel = "_2p-z";
export var optionList = "_2p-f";
export var optionPill = "_2p-13";
export var optionPillBadge = "_2p-16";
export var optionPillIcon = "_2p-14";
export var optionPillLabel = "_2p-15";
export var optionRadio = "_2p-10";
export var optionRadioInner = "_2p-11";
export var optionReveal = "_2p-i";
export var optionRevealDelay0 = "_2p-j";
export var optionRevealDelay1 = "_2p-k";
export var optionRevealDelay10 = "_2p-t";
export var optionRevealDelay11 = "_2p-u";
export var optionRevealDelay2 = "_2p-l";
export var optionRevealDelay3 = "_2p-m";
export var optionRevealDelay4 = "_2p-n";
export var optionRevealDelay5 = "_2p-o";
export var optionRevealDelay6 = "_2p-p";
export var optionRevealDelay7 = "_2p-q";
export var optionRevealDelay8 = "_2p-r";
export var optionRevealDelay9 = "_2p-s";
export var optionSelected = "_2p-h";
export var questionsBlock = "_2p-18";
export var quote = "_2p-3";
export var spacer = "_2p-b";
export var stepCenteredContent = "_2p-9";
export var stepInner = "_2p-6";
export var stepInnerFullWidth = "_2p-7";
export var stepInnerLockScroll = "_2p-8";
export var stepTransitionFrame = "_2p-a";
export var subtitle = "_2p-e";
export var testimonial = "_2p-2";
export var title = "_2p-c";
export var titleWithAccessory = "_2p-d";
export var trustedBy = "_2p-0";
export var trustedByLabel = "_2p-1";
export var welcomeBlock = "_2p-17";